import React, { useState, useEffect } from "react";
import "../../assets/css/svg_popup.scss";

const SvgPopup = ({ svgUrl, storageKey = "hidePopupUntil" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hideUntil = localStorage.getItem(storageKey);
    const now = new Date().getTime();

    if (!hideUntil || now > parseInt(hideUntil)) {
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleHideForDay = () => {
    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    localStorage.setItem(storageKey, tomorrow.getTime().toString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="svg-popup-overlay" onClick={handleClose}>
      <div className="svg-popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-btn" onClick={handleClose}>
          ✕
        </button>

        <div className="svg-content">
          <img src={svgUrl} alt="팝업 이미지" />
        </div>

        <div className="popup-actions">
          <button className="hide-day-btn" onClick={handleHideForDay}>
            하루동안 보지 않기
          </button>
          <button className="close-btn" onClick={handleClose}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default SvgPopup;
